<button class="icon-button" mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="avatar">
        <mat-icon [svgIcon]="'account_circle'"></mat-icon>
    </span>
</button>

<mat-menu class="user-actions-menu" [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="user-info">
            <span>Signed in as </span>
            <span class="email" *ngIf="user">{{user.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <a [routerLink]="['user', 'profile']" mat-menu-item>
        <mat-icon [svgIcon]="'account_circle'"></mat-icon>
        <span>Profile</span>
    </a>
    <a [routerLink]="['admin']" mat-menu-item>
        <mat-icon [svgIcon]="'settings'"></mat-icon>
        <span>Administration</span>
    </a>
    <mat-divider class="my-2"></mat-divider>
    <a [routerLink]="['sign-out']" mat-menu-item>
        <mat-icon [svgIcon]="'power_settings_new'"></mat-icon>
        <span>Sign out</span>
    </a>
</mat-menu>
